<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="'Companies Information'"            
            v-bind:titleRef="'titleElementProviders'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Please, fill out this form with the relevant information about your company. The <b>Provider</b> field refers to your <b>billing entity</b>. When you are done, hit the <b>Save</b> button and move to the next section.
        </p>

        <b-row class="mt-3" v-if="this.ProvidersList.length > 1">           
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Provider'"
                        v-bind:Options="ProvidersList"
                        v-bind:FieldDescription="'companyName'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'providerCode'"
                        v-bind:Model="Provider"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownProviders"/>
            </b-col>
            <b-col lg="9" md="9" sm="12">
              <p class="text-muted mt-4">Select your billing entity provider</p>
            </b-col>     
        </b-row>
        <!--<b-row class="mt-3">
            <b-col md="3">
               <MdCheckBox
                  v-bind:Label="'Use Company Information'"
                  v-bind:Name="'checkbox-UseCompanyInfo'"
                  v-bind:ClassProp="'AlignCheck'"
                  v-bind:CheckedValue="true"
                  v-bind:UncheckedValue="false"
                  v-on:change="onChangeUseCompanyInfo"
                  v-model="UseCompanyInfo"                 
               />
            </b-col>
        </b-row>-->
        <b-row class="mt-3">
           <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Company Npi'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="15" 
                    v-bind:Name="'iProviderIdNpi'"
                    v-model="ProviderIdNpi"                 
                    v-bind:Id="'iProviderIdNpi'"/>      

          </b-col>  
          <b-col lg="9" md="9" sm="12">
            <p class="text-muted mt-4">Indicate your National Provider Identifier (NPI).
            </p>
          </b-col> 
      
         <b-col lg="3" md="3" sm="12" class="customCol">  
             <MdButton
                v-bind:isReadOnly="false"
                v-bind:Label="'Get Company Information By NPI'"
                v-bind:Name="'btngetInfoNPI'"
                v-on:click="getInfoNpi()"
                v-bind:ClassProp="'btn-login'"/>            
         </b-col>
        </b-row>
        <MdTitle v-bind:Text="'General Information'"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>  
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Company Name'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="50" 
                    v-bind:Name="'ifullName'"
                    v-model="CompanyName"                 
                    v-bind:Id="'ifullName'"/>  
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Display Name'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="40" 
                    v-bind:Name="'iDisplayName'"
                    v-model="DisplayName"                 
                    v-bind:Id="'iDisplayName'"/>  
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Contact'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="30" 
                    v-bind:Name="'iContact'"
                    v-model="Contact"                 
                    v-bind:Id="'iContact'"/>  
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Address 1'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="255" 
                    v-bind:Name="'iaddress1'"
                    v-model="address1"                 
                    v-bind:Id="'iaddress1'"/>   
            </b-col> 
        </b-row>
        <b-row>            
            <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Address 2'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="255" 
                    v-bind:Name="'iaddress2'"
                    v-model="address2"                 
                    v-bind:Id="'iaddress2'"/>      
            </b-col>  
             <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Zip'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="9" 
                    v-bind:Name="'iZip'"
                    v-on:blur="ZipBlur(Zip)"
                    v-model="Zip"                 
                    v-bind:Id="'iZip'"/>      
            </b-col>
            <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'City'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="255" 
                    v-bind:Name="'icity'"
                    v-model="City"                 
                    v-bind:Id="'icity'"/>      
            </b-col> 
             <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'State'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="2" 
                    v-bind:Name="'iState'"
                    v-model="State"                 
                    v-bind:Id="'iState'"/>
            </b-col>    
        </b-row>

        <b-row>           
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Country'"
                        v-bind:Options="CountryList"
                        v-bind:FieldDescription="'name'"
                        v-bind:IsDisabled="ReadOnly"
                        v-bind:FieldCode="'recId'"
                        v-bind:Model="Country"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownCountry"/>
            </b-col>
             <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'Phone'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="255" 
                  v-bind:Name="'CellPhone'"
                  v-model="Phone"               
                  v-bind:Id="'iCellPhone'"/> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Fax'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="255" 
                    v-bind:Name="'iFax'"
                    v-model="Fax"                 
                    v-bind:Id="'iFax'"/>      
            </b-col> 
              <b-col lg="3" md="3" sm="12">
                <MdEdit 
                  v-bind:Label="$t('Shared.Email')"
                  v-bind:TypeProp="'email'"
                  v-bind:MaxLengthProp="75" 
                  v-bind:Name="'email'"
                  v-model="Email"                 
                  v-bind:Id="'iEmail'"/>     
               </b-col>                  
        </b-row>    

          <b-row class="mt-3">
            <b-col md="4">
               <MdCheckBox
                  v-bind:Label="'Billing address is different from the company address'"
                  v-bind:Name="'checkbox-1'"
                  v-bind:ClassProp="'AlignCheck'"
                  v-bind:CheckedValue="true"
                  v-bind:UncheckedValue="false"
                  v-on:change="onChangeUseBilling"
                  v-model="isVisibleBilling"                 
               />
            </b-col>
        </b-row>

        <div v-if="VisibleBilling">
          <MdTitle v-bind:Text="'Billing Address'"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
          
          <b-row>
                <b-col lg="3" md="3" sm="12">
                      <MdEdit 
                          v-bind:Label="'Billing Company Name'"
                          v-bind:TypeProp="'text'"
                          v-bind:isReadOnly="ReadOnly"
                          v-bind:MaxLengthProp="50" 
                          v-bind:Name="'ibillingName'"
                          v-model="BillingCompanyName"                 
                          v-bind:Id="'ibillingName'"/>  
                  </b-col>
                  <b-col lg="3" md="3" sm="12">
                      <MdEdit 
                          v-bind:Label="'Address 1'"
                          v-bind:TypeProp="'text'"
                          v-bind:isReadOnly="ReadOnly"
                          v-bind:MaxLengthProp="255" 
                          v-bind:Name="'iBillingaddress1'"
                          v-model="Billingaddress1"                 
                          v-bind:Id="'iBillingaddress1'"/>   
                  </b-col> 
                  <b-col lg="3" md="3" sm="12">
                      <MdEdit 
                          v-bind:Label="'Address 2'"
                          v-bind:TypeProp="'text'"
                          v-bind:isReadOnly="ReadOnly"
                          v-bind:MaxLengthProp="255" 
                          v-bind:Name="'iBillingaddress2'"
                          v-model="Billingaddress2"                 
                          v-bind:Id="'iBillingaddress2'"/>      
                  </b-col>  
                  <b-col lg="3" md="3" sm="12">
                      <MdEdit 
                          v-bind:Label="'Zip'"
                          v-bind:TypeProp="'text'"
                          v-bind:isReadOnly="ReadOnly"
                          v-bind:MaxLengthProp="10" 
                          v-bind:Name="'iBillingZip'"
                          v-model="BillingZip"                 
                          v-bind:Id="'iBillingZip'"/>      
                  </b-col>
          </b-row>

          <b-row>
                  <b-col lg="3" md="3" sm="12">
                      <MdEdit 
                          v-bind:Label="'City'"
                          v-bind:TypeProp="'text'"
                          v-bind:isReadOnly="ReadOnly"
                          v-bind:MaxLengthProp="255" 
                          v-bind:Name="'iBillingcity'"
                          v-model="BillingCity"                 
                          v-bind:Id="'iBillingcity'"/>      
                  </b-col> 
                  <b-col lg="3" md="3" sm="12">
                      <MdEdit 
                          v-bind:Label="'State'"
                          v-bind:TypeProp="'text'"
                          v-bind:isReadOnly="ReadOnly"
                          v-bind:MaxLengthProp="2" 
                          v-bind:Name="'iBillingState'"
                          v-model="BillingState"                 
                          v-bind:Id="'iBillingState'"/>
                  </b-col>  
                  <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="'Phone'"
                        v-bind:TypeProp="'text'"
                        v-bind:MaxLengthProp="255" 
                        v-bind:Name="'iBillingPhone'"
                        v-model="BillingPhone"               
                        v-bind:Id="'iBillingPhone'"/> 
                  </b-col>
                  <b-col lg="3" md="3" sm="12">
                      <MdEdit 
                          v-bind:Label="'Fax'"
                          v-bind:TypeProp="'text'"
                          v-bind:isReadOnly="ReadOnly"
                          v-bind:MaxLengthProp="255" 
                          v-bind:Name="'iBillingFax'"
                          v-model="BillingFax"                 
                          v-bind:Id="'iBillingFax'"/>      
                  </b-col>           
          </b-row> 
        </div>
     
     <MdTitle v-bind:Text="'Additional Information'"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

     <b-row>
        <b-col lg="3" md="3" sm="12"> 
            <MdLookup 
                v-bind:ModelCode="taxonomyCode"
                v-bind:ModelDescription="iTaxonomyDescrip"
                v-bind:Label="'Taxonomy'"
                v-bind:RefCode="'Taxonomy'"   
                v-bind:Api="'GlobalCodes?CodeType=TAXONOMY'"
                v-bind:FieldCode="'code'"
                v-bind:IsDisabled="ReadOnly"
                v-bind:FieldDescription="'description'"                          
                :SearchTitle="$t('Shared.Taxonomy')"
                :GetValues="onCodeConditionOk"
                :InvalidFeedback="$t('ModalCategory.fBakInvCatMsg')"
                :SearchFieldCode="'Code'"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Federal Tax Id'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="10" 
                    v-bind:Name="'iFederalTaxId'"
                    v-model="FederalTaxId"                 
                    v-bind:Id="'iFederalTaxId'"/>      
        </b-col>        
        <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Clia'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="20" 
                    v-bind:Name="'iClia'"
                    v-model="Clia"                 
                    v-bind:Id="'iClia'"/>      
        </b-col>               
     </b-row>

     <MdTitle v-bind:Text="'Company Logo and Motto'"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
     <b-row>
         <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Motto'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:MaxLengthProp="60" 
                    v-bind:Name="'iCompanyMotto'"
                    v-model="CompanyMotto"                 
                    v-bind:Id="'iCompanyMotto'"/>      
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdFile 
            v-bind:Label="'Logo'" 
            v-bind:Id="'IdLogo'"
            v-bind:ModelDescription="DescFile"
            v-bind:RefCode="'iLogo'"          
            @ModelFile="OnModel($event)" 
            />
        </b-col>       
     </b-row> 

        <div class="space-actions"></div>
        <div class="page-actions">

       <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"
            v-bind:Name="'btnProviders'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnProviders'"
            v-bind:ClassProp="'mx-2'"/>      

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-on:click="Update"
            v-bind:Name="'btnProviders'"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import CountryService from '@/services/country.service'
import GlobalService from '@/services/global.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import ISetup from '@/services/isetup.service'
import { EventBus } from '@/event-bus.js';

export default {
  name: 'IniProviders',
   mixins: [ShowMessage, DBFunctions],
  data(){
    return{
        Logo:[],
        VisibleBilling:false,
        ReadOnly:false,
        isVisibleBilling:false,
        UseCompanyInfo:false,
        UseCompanyAddress:false,
        CountryList:[],
        TimeZoneList:[],
        ProvidersList:[],
        Provider:{providerCode:"",companyName:""},
        DescFile:"",
        taxonomyCode:"",
        iTaxonomyDescrip:"",
        CompanyName:"",
        DisplayName:"",
        Contact:"",
        address1:"",
        address2:"",
        Zip:"",
        City:"",
        State:"",
        Country:{name:"",recId:""},
        Phone:"",
        Fax:"",
        Email:"",
        BillingCompanyName:"",
        Billingaddress1:"",
        Billingaddress2:"",
        BillingZip:"",
        BillingCity:"",
        BillingState:"",
        BillingPhone:"",
        BillingFax:"",
        FederalTaxId:"",
        ProviderIdNpi:"",
        Clia:"",
        CompanyMotto:"",
        TimeZone:""

    }
  },
  methods:{
    Next(){
        this.$router.push({ name:'iroles'});
    },

    Back(){
        this.$router.push({ name:'icompany'}); 
    },

    OnModel(file){
       this.Logo = file;
       this.DescFile = this.Logo.length > 0 ? this.Logo[0].fileName :"";
    },

    onChangeUseBilling(item){
      this.VisibleBilling = item;
      /*if(item){
        this.BillingCompanyName = this.CompanyName;
        this.Billingaddress1 = this.address1;
        this.Billingaddress2 = this.address2;
        this.BillingZip = this.Zip;
        this.BillingCity = this.City;
        this.BillingState = this.State;
        this.BillingPhone = this.Phone;
        this.BillingFax = this.Fax;
      }else{
        this.BillingCompanyName = "";
        this.Billingaddress1 = "";
        this.Billingaddress2 = "";
        this.BillingZip = "";
        this.BillingCity = "";
        this.BillingState = "";
        this.BillingPhone = "";
        this.BillingFax = "";

      }*/
    },

   async onChangeUseCompanyInfo(item){      
      if(item){
        await this.getAllCompanies();
        if(this.CompaniesList.length > 0){
          this.address1 = this.CompaniesList[0].address1;
          this.address2 = this.CompaniesList[0].address2;
          this.City = this.CompaniesList[0].city;
          this.State = this.CompaniesList[0].state;
          this.Zip = this.CompaniesList[0].zip;
          this.State = this.CompaniesList[0].state;
          this.Country.recId = this.CompaniesList[0].countryCode.toString();
          this.Country.name = this.CompaniesList[0].country;
          this.Phone = this.CompaniesList[0].phone;
          this.Fax = this.CompaniesList[0].fax;
          this.Contact = this.CompaniesList[0].contactPerson;
          this.CompanyName = this.CompaniesList[0].companyName;
        }  
      }
    },

    ChangeDropDownCountry(){

    },

    ChangeDropDownTimeZone(){

    },

     ZipBlur: function (value) {
          if(value.trim()!== '') {
            this.$emit('load', true); 
            GlobalService.getCityAndStateByZipCode(value)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        var obj = response.data
                       if(obj.city) {
                            this.City = obj.city;
                            this.State = obj.state;
                        }
                       // this.patientZipChanged = false;
                    }  
                     this.$emit('load', false);                          
                })
                .catch((error) => {
                    this.$emit('load', false); 
                    this.City = '';
                    this.State = '';
                  if(error.response.status !== 404 && error.response.status !== 500){
                      if(error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  }
                    
                });  
            }
        },

    async getAllCompanies(){    
      await ISetup.getAllCompanies()
      .then((response) => {      
           if (response.status == "200" && response.data.length > 0) {
                this.CompaniesList = response.data;                                
           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    ChangeDropDownProviders(item){
        if(item !== null){
            this.Provider.providerCode = item.providerCode;
            this.Provider.companyName = item.companyName;
            this.getProviderByCode(this.Provider.providerCode);
        }
    },

    onCodeConditionOk(result){
       var type = result.FieldName;
          if (type.indexOf('Taxonomy') >= 0) {               
              this.iTaxonomyDescrip = result.description;
              this.taxonomyCode = result.code;
          } 
    },

     async getAllCountries(){    
       await CountryService.getCountries()
      .then((response) => {      
           if (response.status == "200") {
                this.CountryList = response.data;
           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

      async getInfoNpi(){   
        this.$emit('load', true);  
       await ISetup.getInfoByNPICompany(this.ProviderIdNpi)
      .then((response) => {      
           if (response.status == "200") {
               let data = response.data;
               this.CompanyName = data.companyName;
               this.address1 = data.address1;
               this.address2 = data.address2;
               this.Zip = data.zip;
               this.City = data.city;
               this.State = data.state;
               this.Phone = data.phone;
               this.Fax = data.fax;
               this.taxonomyCode = data.taxonomyCode;
               this.iTaxonomyDescrip = data.taxonomyDescription;
               this.FederalTaxId = data.federalTaxId;
               this.Clia = data.clia;
              // this.Country = data.companyName;
              // this.Country.name = data.country;
              // this.Country.recId = data.countryCode;
           }
           this.$emit('load', false); 
      })
      .catch(error => {
        this.$emit('load', false); 
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    async getProviderByCode(Code){    
      await ISetup.GetSetupProvider(Code)
      .then((response) => {      
           if (response.status == "200") {
                let data = response.data; 
                this.CompanyName = data.companyName;
                this.DisplayName = data.displayName;
                this.Contact = data.contact;
                this.address1 = data.address1;
                this.address2 = data.address2;
                this.Email = data.email;
                this.Zip = data.zip;
                this.City = data.city;
                this.State = data.state;
                this.Country.name = data.country;
                this.Country.recId = data.countryCode;
                this.Phone = data.phone;
                this.Fax = data.fax;               
                this.FederalTaxId = data.federalTaxId;
                this.ProviderIdNpi = data.providerIdNpi;
                this.Clia = data.clia;
                //this.TimeZone = data.timeZone;
                this.taxonomyCode = data.taxonomyCode;
                this.iTaxonomyDescrip = data.taxonomyDescription;
                this.CompanyMotto = data.companyMotto;
                this.DescFile = data.logoNameAndExtension;
              
                var baseurl = this.$store.state.apiurl.replace('/api/', '');                   
                let FullUrl = baseurl+"/setuplogos/"+this.Provider.providerCode+"_"+data.logoNameAndExtension; 
                EventBus.$emit('onUpdateFileNameAndUrl', {fileName:data.logoNameAndExtension,url:FullUrl}); 
                               

           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

     Update(){ 
         let data = {
            CompanyName:this.CompanyName,
            Contact:this.Contact,
            Address1:this.address1,
            Address2:this.address2,
            City:this.City,
            State:this.State,
            Country:this.Country.name,
            Zip:this.Zip,
            Phone:this.Phone,
            Fax:this.Fax,
            BillingCompanyName:this.BillingCompanyName,
            Billingaddress1:this.Billingaddress1,
            Billingaddress2:this.Billingaddress2,
            BillingZip:this.BillingZip,
            BillingCity:this.BillingCity,
            BillingState:this.BillingState,
            BillingPhone:this.BillingPhone,
            BillingFax:this.BillingFax,    
            TaxonomyCode:this.taxonomyCode,
            FederalTaxId :this.FederalTaxId,
            ProviderIdNpi:this.ProviderIdNpi,
            Clia:this.Clia,
            CompanyMotto:this.CompanyMotto,
            LogoNameAndExtension:this.Logo.length > 0 ? this.Logo[0].fileName : null,
            Contents:this.Logo.length > 0 ? this.Logo[0].contents : null
          //  TimeZone:this.TimeZone 
         }   
        
        this.$emit('load', true);       
      ISetup.UpdateProvider(this.Provider.providerCode,data)
        .then((response) => {
          if (response.status == '200') {
                this.pendingChanges = false;  
                this.$emit('load', false);
                 setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50);
                               
          }
        })
        .catch((error) => {
          this.$emit('load', false);
          // elemSaveBtn.removeAttribute("disabled"); 
            this.showResponseErrorMessage(error);
        });
    },

    async getProviders(){   
      this.$emit('load', true);   
      await ISetup.getAllSetupProviders()
      .then((response) => {      
           if (response.status == "200") {              
                this.ProvidersList = response.data;
                if(this.ProvidersList.length >= 1){
                    this.Provider.providerCode = this.ProvidersList[0].providerCode;
                    this.Provider.companyName = this.ProvidersList[0].companyName;
                    this.getProviderByCode(this.Provider.providerCode);
                }
                this.$emit('load', false);
           }
           this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

  },

  async created(){
    await this.getAllCountries();
    await this.getProviders();
   
  },
  mounted(){

  }   
};
</script>


<style scoped>
.customCol {
  display: flex;
/*/  flex-direction: column;*/
  align-items: center;
/*  height: calc(50% + 19px);*/
  justify-content: space-between;
}
</style>

